import { Box, withStyles } from '@material-ui/core';

export const ListContainer = withStyles({
  root: {
    flex: 1,
    height: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    scrollBehavior: 'smooth',
    padding: '12px 20px',
    paddingTop: 0,
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  }
})(Box);
